import $ from 'jquery';
import Cookies from "js-cookie";
import Texter from "./texter.es6";

import * as CSS from  'bundle-text:./packPagePromo.css';

require('jsrender')($);

const PROMO_COOKIE = 'ppp0';


const PROMO_CONTENT = $.templates(`
<style>${CSS}</style>
<div class="ppp0">
    <a class="ppp0__close" data-click="close"><i class="far fa-times"></i></a>
    <div class="ppp0__title text-center">{{>~l18n.get('ppp0.title')}}</div>
    <div class="ppp0__body">
        <div class="row align-items-start">
            <div class="col-4 text-center">
                <a class="mb-2 ppp0__block" href="{{:urlPlay}}">
                    <i class="far fa-credit-card-front ppp0__icon"></i>
                    <span class="ppp0__label">{{>~l18n.get('packPage.button.play')}}</span>                
                </a>            
            </div>
            <div class="col-4 text-center">
                <a class="mb-2 ppp0__block" href="{{:urlShort}}">
                    <i class="far fa-chalkboard-teacher ppp0__icon"></i>
                    <span class="ppp0__label">{{>~l18n.get('packPage.solw.short')}}</span>                
                </a>            
            </div>
            <div class="col-4 text-center">
                <a class="mb-2 ppp0__block" href="{{:urlLong}}">
                    <i class="far fa-repeat ppp0__icon"></i>
                    <span class="ppp0__label">{{>~l18n.get('packPage.solw.long')}}</span>                
                </a>            
            </div>
        </div>
    </div>
</div>
`);


export class PackPagePromo {
    constructor({l18n}) {
        this.l18n = Texter.create(l18n);
        this.visible = false;

        this.enabled = !Cookies.get(PROMO_COOKIE);
        if (!this.enabled) {
            return;
        }

        this.window = $(window);
        this.window.scroll(() => this._onScroll());

        this._onScroll();
    }

    _onScroll() {
        if (!this.enabled) {
            return;
        }

        const K = .5;
        if (this.window.scrollTop() > K * this.window.height()) {
            this._showPromo();
        } else {
            this._hidePromo();
        }
    }

    _showPromo() {
        if (this.visible) {
            return;
        }

        const model = {
            urlPlay: document.location.href.replace('/set/', '/play/'),
            urlShort: document.location.href.replace('/set/', '/learn/'),
            urlLong: document.location.href.replace('/set/', '/memo/')
        };
        this.visible = true;

        this.promo = $(PROMO_CONTENT.render(model, this)).appendTo('body');
        this.promo.find('a[data-click=close]').click(() => {
            Cookies.set(PROMO_COOKIE, false, {expires: 365});
            this.enabled = false;
            this._hidePromo();
            return false;
        });
    }

    _hidePromo() {
        if (!this.visible) {
            return;
        }

        this.visible = false;
        this.promo.remove();
        this.promo = null;
    }
}